import React from 'react';
import './OperationsWrapper.less';
import { jsx as _jsx } from "react/jsx-runtime";
export const OperationsWrapper = props => {
  return /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-pro-table-operations-wrapper",
    ...props
  });
};
//# sourceMappingURL=es/OperationsWrapper.js.map